import { Component } from "react";
import React from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import {
  Card, CardBody,
  Modal, ModalHeader, ModalBody, ModalFooter,
  CardTitle, Form, Row, FormGroup, Button, Col, Spinner, Input
} from 'reactstrap';
import axios from "axios";
import appConfig from '../../config/config';
import { connect } from "react-redux";
import Banner from "../common/banner";
import DropdownList from 'react-widgets/lib/DropdownList';


class UploadDoc extends Component {
    state = {
        // Initially, no file is selected
        selectedFile: null, loading :false,
        showBanner: false, message: '',display:true,
        documentType:''
      };
      closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }
      onFileChange = event => {
        // Update the state
        this.setState({ selectedFile: event.target.files[0] });
      
      };
      async getFileInfo(){
        console.log(this.state)
        var fileinfo = await axios.post(
          appConfig.apiGateway.getDocUrl,
          JSON.stringify({
              OrderId: this.props.OrderId,
              OrderItemId: this.props.OrderProductId,
              Action: "DocName",
              DocumentType : this.state.documentType,
              FileType: this.state.selectedFile.name.split('.').pop(),
              UserName: this.props.session.session.user.name
          }),
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
              }
          }
      )
      return fileinfo
      }
      readUploadedFile = (inputFile) => {
        const temporaryFileReader = new FileReader();
        return new Promise((resolve, reject) => {
          temporaryFileReader.onerror = () => {
            temporaryFileReader.abort();
            reject(new DOMException("Problem parsing input file."));
          };
          temporaryFileReader.onload = () => {
            resolve(temporaryFileReader.result);
          };
          temporaryFileReader.readAsArrayBuffer(inputFile);
        });
      };
      onFileUpload =  (file) => {
        // Create an object of formData
         if (file == null) {
          this.setState({...this.state,showBanner:true, isSuccess:false, message:'Please select file.'})
          return;
         }
         if (this.state.documentType == null || this.state.documentType == '') {
          this.setState({...this.state,showBanner:true, isSuccess:false, message:'Please document type'})
          return;
         }

         this.setState({...this.state, loading:true})
         var response =  this.getFileInfo()
         response.then(async(r)=>{
          //var myObject = JSON.parse(response.data);
            if (r.data.status ) {
             var data = await this.readUploadedFile(file)
             axios.put(
                r.data.body.fileurl,data).then(
                    (r)=>{
                      this.props.Reload()
                      this.setState({...this.state, loading:false})
                      this.props.Upload(false)
                    },
                    (e)=>{
                      this.setState({...this.state, loading:false})
                    })
                  }
                  else {
              this.setState({...this.state,showBanner:true, 
                loading:false,
                isSuccess:false, message:'Upload error. please contact system admin.'})
            }
      })
    }
      renderDocumentType()
      {
        var doclist = ['Appraisal report',
        'Appraisal Invoice',
        'Compliance certificate',
        'Property report',
        'Deed Copy',
        'Property Report Update',
        'Property report Invoice',
        'Full search',
        'Search invoice',
        'Property Condition report',
        'Recorded Document',
        'Recording invoice',
        'Property Condition report Invoice']
        var salesdoclist = ['Invoice','Final Report PDF','Final Report XML']


        if (this.props.LOS == 'MLINK')
        return (
          <DropdownList  
          data={doclist}
          value={this.state.documentType}
          name="description" 
          onChange={(e)=> this.setState({...this.state,documentType : e})}
          />
        );
        else if (this.props.LOS == 'SALESF')
        return (
          <DropdownList  
          data={salesdoclist}
          value={this.state.documentType}
          name="description" 
          onChange={(e)=> this.setState({...this.state,documentType : e})}
          />
        );
        else
        return(
          <input  className="col-6" type="text" name="description" value={this.state.documentType}
          onChange={(e)=> this.setState({...this.state,documentType : e.target.value})}
          ></input>
        );
      }
      render() {
        const file = this.state.selectedFile
        return (
          <Modal
          isOpen={this.state.display}
          toggle={this.toggle}
          contentClassName="custom-modal-style"
          >
          <ModalHeader>Upload Document</ModalHeader>
                  <ModalBody>{this.state.showBanner && (
                      <Banner
                        Close={this.closeBanner}
                        message={this.state.message}
                        IsSuccess={this.state.isSuccess}
                      />
                    )}
                    <form>
                      <Row form>
                        <Col md={12}>
                          <input className="col-12" style={{paddingLeft:'0px'}} type="file" onChange={this.onFileChange} />
                        </Col>
                        <Col md={12} style={{marginTop:'20px'}}>
                         <span className="col-6" style={{paddingLeft:'0px'}}>Document Type</span>
                        {this.renderDocumentType()}


                        </Col>
                      </Row>
                    </form>                   
                    </ModalBody>

                  <ModalFooter>   
                    <Button color="primary" onClick={() => this.onFileUpload(file)}>
                      {this.state.loading && <Spinner />}
                      {!this.state.loading && <span>Save</span>}
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => this.props.Upload(false)}>
                      Cancel
                    </Button>
                  </ModalFooter>
                  </Modal>
        );
        }
      
    }    
    var uploadDoc =  reduxForm({
        form: "myfileupload"
      })(UploadDoc);
      uploadDoc = connect(
        state => ({
            session: state.session
        })
    )(uploadDoc);
    
    export default uploadDoc;